// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__f+bdi","dashboardInvoicing":"Dashboard_dashboardInvoicing__yMnQF"};